import type { PortalActionType } from './PortalDuck.actions'
import type { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import SagaDuck from '@duckness/saga'

type PortalDuckSelectorsType = {
  currentData: <R = InsightsDashboardPoolState['currentData']>(state: InsightsDashboardPoolState) => R
}

export const TypedSagaDuck = SagaDuck<InsightsDashboardPoolState, PortalActionType, PortalDuckSelectorsType>
